// The ambient GROUND (DESIGN-WL-HOME-SKY-TOP-GROUND-1, Nika 2026-10-01: "very
// end of scroll we show some bottom part revealing with smooth scroll in
// homepage").
//
// A decorative band along the bottom edge of the screen: fixed, no pointer
// events, hidden from assistive tech, under the page stage like the sky
// (zIndex -1 in the shell root's stacking context). The art is the loader's
// mountain range (files/ambient/mountains.png, the same 1-bit dot language)
// in the loader's own ink (`loaderInk`), so the home ENDS where the loader
// began. `groundSky` names another mask from the catalogue (e.g. 'clouds').
//
// THE RISE. At rest the band sits one band-height below the edge (Rise's
// translateY(100%)), so nothing shows while the home is scrolled above its
// end. The shell's injected sheet (app.js) moves Rise:
//   * scroll-driven (CSS `animation-timeline` on the home scroller's named
//     timeline, scoped to the shell root): Rise climbs to translateY(0) over
//     the last stretch of the home scroll (40vh), scroll-linked;
//   * no scroll-driven animations: the home's end sentinel toggles
//     `groundIn` here (functions/ambientBackdrop.js ambientGroundWatch) and
//     the sheet runs a transform transition on `data-ground="in"`;
//   * reduced motion (the OS query, or <html data-motion="reduced">): no
//     motion — the band simply shows at the end.
// Transforms only: no layout, no mask position. A short home (no scroll) has
// no end to reach, so the ground stays down (ambientGroundProgress).
//
// THE SKIN and THE ROUTE are never read here: the frame is display none; the
// sheet shows it for the ambient skin on the home route only. Its own off
// switches are the sky's (`ambientGroundState` asks `ambientSkyState`), plus
// its art's files-plane record. Every factory stands alone (frank).

export const AmbientGround = {
  groundSky: 'mountains',
  state: { groundIn: false },

  aria: { hidden: 'true' },
  attr: { 'data-ground': (el, s) => (s.groundIn ? 'in' : 'out') },
  display: 'none',
  position: 'fixed',
  left: '0',
  right: '0',
  bottom: '0',
  height: 'groundBand',
  zIndex: '-1',
  pointerEvents: 'none',
  overflow: 'hidden',

  hide: (el, s) => !el.call('ambientGroundState', s, el.groundSky).enabled,

  Rise: {
    position: 'absolute',
    inset: '0',
    pointerEvents: 'none',
    transform: 'translateY(100%)',
    Art: {
      position: 'absolute',
      inset: '0',
      pointerEvents: 'none',
      background: 'loaderInk',
      maskImage: (el, s) =>
        el.call(
          'ambientMaskImage',
          el.call('ambientGroundState', s, el.parent.parent.groundSky).url
        ),
      maskSize: 'auto 100%',
      maskRepeat: 'repeat-x',
      maskPosition: 'center bottom'
    }
  }
}
